import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_STARTER_EXPERIENCE_DASHBOARD_SUNRISE = createFcmDetails(
	'starter_experience_dashboard_sunrise',
	{
		owner: 'Axolotl Squad',
		context: 'Starter Dashboard',
		description: 'Controls the visibility of the Sunrise Starter Experience Dashboard',
		import: false,
		template: {
			experimentName: 'starter_experience_dashboard_sunrise_v1',
			enabled: false,
		},
		mergeLogic: 'Displays in order of country then locale',
	},
);
